let httpurl = {
	src:'https://bmapi.sjzsdx.cn', // 正式地址
	// src:'https://daoxie.jiyuechuxing.com',
	// src:'http://192.168.120.111:8089',
	// src: 'https://22878gjft624.vicp.fun',
	// src:'http://192.168.12.205:8088',
	// src:'http://sf.19940309.xyz:8032',
	// src:'https://daoxie.hellouxing.com/dx_test',
//	src:'http://19940309.xyz:20005',

}

export default httpurl
